import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            seo: {
                title: this.projectName,
                description: '',
                img: '',
                keywords: ''
            }
        };
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            getCurrentTheme: 'global/getCurrentTheme'
        }),
        projectName() {
            return this.globalSettings.project;
        },
        defaultImage() {
            if (this.getCurrentTheme === 'light-theme') {
                return this.globalSettings.logo?.logoLight;
            }
            return this.globalSettings.logo?.logoDark;
        }
    },
    methods: {
        async fetchSEO(url) {
            try {
                let seo = await this.$axios.$get(url);
                if (seo) {
                    this.seo.title = seo.title;
                    this.seo.description = seo.description;
                    this.seo.img = seo.img;
                    this.seo.keywords = seo.keywords;
                }
            } catch (error) {
                throw new Error(`Failed to load seo of '${url}'`);
            }
        },
        setDataSEO({ title, description, img, keywords }) {
            this.seo.title = title;
            this.seo.description = description;
            this.seo.img = img;
            this.seo.keywords = keywords;
        }
    },
    head() {
        const micromarking = this.globalSettings?.micro_pagination_settings;
        return {
            title: this.seo.title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.seo.description
                },
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.seo.title
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: this.seo.description
                },
                {
                    hid: 'og:image',
                    property: 'og:image',
                    content: this.seo.img || this.defaultImage
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: this.seo.keywords
                }
            ],
            script: micromarking
                ? [
                      {
                          type: 'application/ld+json',
                          json: {
                              '@context': 'https://schema.org',
                              '@type': 'Organization',
                              url: micromarking.url,
                              name: process.env.PUBLIC_NAME,
                              sameAs: micromarking.optional_urls,
                              description: micromarking.description,
                              address: {
                                  '@type': 'PostalAddress',
                                  ...micromarking.address
                              },
                              contactPoint: {
                                  '@type': 'ContactPoint',
                                  ...micromarking.contact_point
                              }
                          }
                      }
                  ]
                : []
        };
    }
};
